var map = {
	"./blog-handshake.jpg": 479,
	"./blog-updates.png": 480
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 478;



//////////////////
// WEBPACK FOOTER
// ../assets/img/posts ^\.\/.*$
// module id = 478
// module chunks = 0